<mat-card class="filter settingHeader" *ngIf="!payCheck">
  <div class="name">
    3rd party Applications
  </div>
  <div class="quickAction">

  </div>

</mat-card>


<div class="oneblk" *ngIf="!payCheck">

  <mat-card class="impBlock" (click)="openDialogWithRef(myDialog)">
    <img
      src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Gmail_icon_%282020%29.svg/1200px-Gmail_icon_%282020%29.svg.png"
      alt="">
    <button mat-icon-button class="remove" (click)="remove()">
      <mat-icon>delete</mat-icon>
    </button>
    <span>Gmail</span>
  </mat-card>


  <mat-card class="impBlock active" (click)="openDialogWithRef(myDialog)">
    <img
      src="https://media-exp1.licdn.com/dms/image/C4E0BAQGgCO8be7TBCw/company-logo_200_200/0/1616101057856?e=1666828800&v=beta&t=ylvYwveFKzEMaixHqYVZLbpaJp7zINjvj91W6Q-c8bk"
      alt="">

      <span>Paychex</span>
  </mat-card>

  <mat-card class="impBlock" (click)="openDialogWithRef(myDialog)">
    <img
      src="https://thumbs.dreamstime.com/b/paypal-logo-printed-paper-chisinau-moldova-september-internet-based-digital-money-transfer-service-128373487.jpg"
      alt="">
      <span>Paypal</span>
  </mat-card>


  <mat-card class="impBlock" (click)="openDialogWithRef(myDialog)">
    <img src="https://bitcoin.org/img/icons/opengraph.png?1657703267" alt="">
    <span>Bitcoin</span>
  </mat-card>


</div>


<div class="documents" *ngIf="payCheck">

  <mat-card class="filter settingHeader">
    <div class="name">
      <button mat-icon-button color="primary" style="margin-left: 0;" (click)="authenticate()"><mat-icon>arrow_back</mat-icon></button> Paychex API



    </div>
    <div class="quickAction">
      <mat-form-field>
        <mat-label>Paychex API's</mat-label>
        <mat-select class="custom-select-style">
          <mat-option [value]="1">Add Worker</mat-option>
          <mat-option value="1">Payment Worker</mat-option>
        </mat-select>
      </mat-form-field>

      <button mat-flat-button color="primary" style="margin-left: 10px" >Add</button>

    </div>

  </mat-card>


  <mat-card class="apiListHolder">
    <div class="allApi">
      <ul>
        <li class="active">Add Worker</li>
        <li>Payment Worker</li>
        <li>Company Checks</li>

        <li>Worker Check</li>
        <li>Company Pay Period</li>
      </ul>
    </div>
    <div class="new-datatable">
      <!-- <div class="required-properties" >
            <div class="required-text">
              <h5>Some required properties are missing</h5>
              <p> Mismatched columns will not be imported         
                To complete your contacts import, you need <span class="color-dark">First Name</span> or <span class="color-dark">last Name</span> or <span class="color-dark">Email</span> as a Hubspot property. Please review your property mappings below or review the columns in your file.</p>
            </div>
          </div> -->

      <div class="table">
        <table>
          <thead>
            <th width="90px"> Sr. No.</th>
            <th width="130px">
              <div class="inline-items-custom">
                <mat-checkbox color="primary"></mat-checkbox>
                Import <i class="fa fa-info-circle" matTooltip="Only selected column header will be import"></i><br>
              </div>
            </th>
            <th>Column Header From File</th>
            <th>System Fields</th>
          </thead>
          <tbody>
            <tr>
              <td>f1</td>
              <td>
                <div class="has-checkbox">
                  <mat-checkbox color="primary"></mat-checkbox>
                </div>
              </td>
              <td>Name</td>
              <td>
                <mat-form-field>
                  <mat-label>Choose fields</mat-label>
                  <mat-select class="custom-select-style">
                    <mat-option [value]="1">1</mat-option>
                    <mat-option value="1">2</mat-option>
                  </mat-select>
                </mat-form-field>

              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </mat-card>


</div>


<ng-template #myDialog>
  <form>
    <h2 mat-dialog-title>
      Authenticate
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content class="mat-typography">
      <mat-form-field class="example-full-width">
        <mat-label>Authentication Token</mat-label>
        <input matInput placeholder="Add Key" />
      </mat-form-field>
      <mat-form-field class="example-full-width">
        <mat-label>Secreat Token</mat-label>
        <input matInput placeholder="Add Key" />
      </mat-form-field>

    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <button mat-button (click)="close()">Cancel</button>
      <button mat-flat-button color="primary" (click)="authenticate()" >Authenticate </button>
    </mat-dialog-actions>

  </form>
</ng-template>